module.exports = __webpack_public_path__ + "static/img/guoyu-logo.6a8d979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guoyu-logo.jpg
// module id = VX65
// module chunks = 2